import React from 'react';
import { number, shape, string } from 'prop-types';
import { fromCents, numberWithCommas } from 'utils/helpers';
import { fieldNames, frequencies } from '../const';
import InputWithGroup from '../reusable/InputWithGroup';
import QuestionText from '../reusable/QuestionText';

const AlternativeIncomeQuestion = (props) => {
  const {
    bankStatementSalary,
    declaredSalary,
    declaredSalaryMonthly,
  } = props;

  const bankStatementSalaryAmount = numberWithCommas(fromCents(bankStatementSalary.amount));
  const declaredSalaryAmount = numberWithCommas(fromCents(declaredSalary.amount));
  const declaredSalaryFrequency = frequencies[declaredSalary.frequency];
  const declaredSalaryMonthlyAmount = numberWithCommas(fromCents(declaredSalaryMonthly.amount));

  return (
    <div className="followup__question-container">

      <QuestionText
        textId="followup.question.alternativeIncome"
        values={{
          bankStatementSalaryAmount,
          declaredSalaryAmount,
          declaredSalaryFrequency,
          declaredSalaryMonthlyAmount,
        }}
      />

      <InputWithGroup
        inputName={fieldNames.alternativeIncomeAmount}
        groupName={fieldNames.alternativeIncomeFrequency}
        errorValues={{ min: 0, max: 30000 }}
      />
    </div>
  );
};


AlternativeIncomeQuestion.propTypes = {
  bankStatementSalary: shape({
    amount: number,
    frequency: string,
  }),
  declaredSalary: shape({
    amount: number,
    frequency: string,
  }),
  declaredSalaryMonthly: shape({
    amount: number,
    frequency: string,
  }),
};

export default AlternativeIncomeQuestion;
